
import { ModelBase } from 'store/model-base';

export class CmsQuickpayBreadcrumbs extends ModelBase {
    public static storeName: string = 'cmsQuickpayBreadcrumbs';

    public header: string;
    public amount: string;
    public method: string;
    public review: string;
    public result: string;
}
